import React from 'react';

interface NoticeProps {
  title: string; // 제목을 위한 prop
  content: React.ReactNode; // 내용을 위한 prop
}

const NoticeComponent: React.FC<NoticeProps> = ({ title, content }) => {
  return (
    <div>
      <h2 className="flex items-center text-3xl Pretendard-Bold mobile:text-lg text-[#000]">
        {title}
      </h2>
      <p className="mb-[20px] Pretendard-Regular text-sm text-[#414042] mobile:text-xs tracking-wide mobile:mt-1 leading-7">
        {content}
      </p>
    </div>
  );
};

export default NoticeComponent;
